@if (bannersGrid$ | async; as banners) {
  <div class="banner-grid-container container-v2">
    @for (banner of banners; track banner.url) {
      <div class="banner-grid" [sdInViewport]="0.5" [intersectedOnce]="true" (intersected)="onBannerIntersect(banner)">
        <sd-generic-link [url]="banner.link" (click)="onBannerClick(banner)">
          <img [ngSrc]="banner.url" [alt]="banner.altText" fill />
        </sd-generic-link>
      </div>
    }
  </div>
} @else if (isLoading$ | async) {
  <div class="banner-grid-container banner-grid-container-skeleton container-v2 sd-group-skeleton-gradient-wave">
    @let numberOfSkeletons = 5;
    @for (i of [].constructor(numberOfSkeletons); track $index) {
      <div class="banner-grid sd-skeleton"></div>
    }
  </div>
}
